"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapValidationErrors = exports.parseValidationError = exports.parseAjaxErrorResponse = void 0;
const fp = require("fp-ts");
const validation_1 = require("../types/validation");
function parseAjaxErrorResponse(res) {
    if (res.status === undefined) {
        return {
            type: 'UNKNOWN_ERROR',
            raw: res
        };
    }
    else if (res.status >= 502 && res.status <= 504) {
        return {
            type: 'CONNECTION_ERROR',
            error: res.response ? res.response.message : res.response
        };
    }
    else if (res.status === 304) {
        return {
            type: 'NOT_MODIFIED'
        };
    }
    else if (res.status === 404) {
        return {
            type: 'NOT_FOUND'
        };
    }
    else if (res.status === 401 && res.response) {
        if (Array.isArray(res.response.message)) {
            if (res.response.message.find((x) => x === 'Invalid token')) {
                return {
                    type: 'INVALID_TOKEN'
                };
            }
        }
        return {
            type: 'PERMISSION_DENIED'
        };
    }
    else if (res.status === 403 && res.response) {
        return {
            type: 'PERMISSION_DENIED'
        };
    }
    else if (res.status === 406) {
        return {
            type: 'NOT_ACCEPTABLE'
        };
    }
    else if (res.status === 409) {
        return {
            type: 'CONFLICT',
            message: res.response.message || ''
        };
    }
    else if (res.status === 413) {
        return {
            type: 'ENTITY_TOO_LARGE'
        };
    }
    else if (res.status === 422) {
        return {
            type: 'API_VALIDATION',
            error: res.response ? res.response.message : res.response
        };
    }
    else if (res.status === 400) {
        return {
            type: 'BAD_REQUEST',
            error: res.response ? res.response.message : res.response
        };
    }
    else if (res.status === 429) {
        return {
            type: 'THROTTLED_ERROR',
            error: res.response ? res.response.message : res.response
        };
    }
    else if (res.status > 400 && res.status <= 500) {
        return {
            type: 'API_ERROR',
            error: res
        };
    }
    return {
        type: 'UNKNOWN_ERROR',
        raw: res
    };
}
exports.parseAjaxErrorResponse = parseAjaxErrorResponse;
function parseValidationError(validationError) {
    const errors = (0, validation_1.reporter)(fp.either.left(validationError));
    return {
        type: 'VALIDATION',
        errors
    };
}
exports.parseValidationError = parseValidationError;
const mapValidationErrors = (errors) => errors.reduce((acc, item) => {
    const err = acc || {};
    (err[item.key] = err[item.key] || []).push(item.value);
    return err;
}, null);
exports.mapValidationErrors = mapValidationErrors;
//# sourceMappingURL=errorHandling.js.map